import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import ReportsService from "../../../../services/ReportsService";
import Pagination from "../Pagination/Pagination";
import { ExportExcel } from "../../../Enums/Export";

const AverageServiceTime = () => {
	const [data, setData] = useState([]);
	const [date, setDate] = useState("");
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);

	const printPage = () => {
		let headRow = [
			Translate[lang].zone_name,
			Translate[lang].average_service_time,
		];
		let dataInfo = data?.map((res) => {
			let info = {
				name: res?.name_en,
				avgTime: res.avgTime,
			};
			return info;
		});
		print("Average Service Time", headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].average_service_time}
				</span>
				<div className="d-flex gap-8">
					<Button variant="outline-primary" onClick={() => ExportExcel(data)}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div className="row mb-4">
				<div className="col-6">
					<input
						type="date"
						value={date}
						className="w-100 h-100"
						style={{
							border: "1px solid #dedede",
							borderRadius: "10px",
							padding: "0 12px",
						}}
						onChange={(e) => setDate(e.target?.value)}
					/>
				</div>
				<div className="col-6">
					<div className="d-flex gap-8">
						<Button
							variant="outline-primary"
							className="w-100"
							onClick={() => setShouldUpdate((prev) => !prev)}>
							{Translate[lang].apply}
						</Button>
						{!!date && (
							<Button
								variant="outline-danger"
								className="w-100"
								onClick={() => {
									setDate("");
									setShouldUpdate((prev) => !prev);
								}}>
								{Translate[lang].clear_filter}
							</Button>
						)}
					</div>
				</div>
			</div>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].zone_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang].average_service_time}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">{item.name_en}</td>
											<td>{item.avgTime}</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={
							!!date
								? {
										date: date,
								  }
								: ""
						}
						type="zonesAVGTime"
					/>
				</div>
			</div>
		</>
	);
};

export default AverageServiceTime;
